import { useRouter } from "next/router";

import { getAppStoreLink, getPlayStoreLink } from "@/common/static/apps.static";

/** Store listing links for the page locale, so every badge resolves to the visitor's storefront. */
export const useStoreLinks = () => {
  const { locale } = useRouter();

  return { ios: getAppStoreLink(locale), android: getPlayStoreLink(locale) };
};
